import React, { Fragment, useCallback, useEffect, memo } from 'react';
import RangeSlider from '../bronson/RangeSlider';

const RangeFilter = ({
    filterTitle,
    filterCode,
    filters,
    updateFilters,
    rangeFilterOptions,
}) => {
    const changeValue = useCallback(
        value => {
            updateFilters({ ...filters, [filterCode]: value });
        },
        [filterCode, filters, updateFilters]
    );

    return (
        <Fragment>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text ">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content"
                aria-hidden="true"
            >
                <div className="c-accordion__content c-vehicle-filters__range c-accordion__content--max-width">
                    {filters?.[filterCode]?.length > 0 ? (
                        <RangeSlider
                            value={filters[filterCode]}
                            setValue={changeValue}
                            options={rangeFilterOptions}
                        ></RangeSlider>
                    ) : null}
                </div>
            </div>
        </Fragment>
    );
};

export default memo(RangeFilter);
